import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const RunActivityPage = lazy(() => import('~/features/catalog-enrichment/pages/run-activity-page'));

/** A batch's Activity tab — every action, attempt and re-run on it. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/activity',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { runId } = Route.useParams();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <RunActivityPage runId={runId} />
    </Suspense>
  );
}
